// extracted by mini-css-extract-plugin
export default {"counterview":"counterview_d12f928a70903c44b933","count":"count_a9edbb483e5021f3b758"};